/**
 * TRTC Web SDK 屏幕共享工具
 * @Author: Assistant
 * @Date: 2025-01-27
 * @Description: 基于TRTC Web SDK的屏幕共享功能实现
 */

import TRTC from 'trtc-js-sdk';

class TRTCScreenShare {
  constructor() {
    this.trtcCloud = null;
  };

  /**
   * 初始化TRTC实例
   * @param {Object} config - TRTC配置
   * @param {string} config.sdkAppId - SDK应用ID
   * @param {string} config.userId - 用户ID
   * @param {string} config.userSig - 用户签名
   * @param {string} config.roomId - 房间ID
   */
  async initTRTC(config) {
    try {
      this.trtcCloud = TRTC.createClient({
        sdkAppId: config.sdkAppId,
        userId: config.userId,
        userSig: config.userSig,
        mode: config.mode || 'rtc',
        useStringRoomId: config.useStringRoomId || false,
      });
      return true;
    } catch (error) {
      console.error('TRTC初始化失败:', error);
      throw error;
    }
  };

  // 【拉流端】拉流并播放
  async streamAdded(options = {}) {
    if (!this.trtcCloud) {
      throw new Error('TRTC实例未初始化');
    };
    if (this.isSharing) {
      console.warn('屏幕共享已在进行中');
      return;
    };

    try {
      const params = {
        roomId: options.roomId,
        elementId: options.elementId,
      };
      const trtcCloud = this.trtcCloud;
      trtcCloud.on('stream-added', async event => {
        const remoteStream = event.stream;
        // 订阅远端流
        await trtcCloud.subscribe(remoteStream);
        // 主路视频流，一般是推麦克风、摄像头的那路流
        if (remoteStream.getType() === 'main') {
          // 1. 在页面中放置一个 id 为 `${params.elementId}_main` 的 div 标签，用于在 div 标签内播放主路流。业务侧可自定义 div 标签的 id，此处只是举例说明。
          // 2. 播放主路视频流
          await remoteStream.play(`${params.elementId}_main`);
        } else if (remoteStream.getType() === 'auxiliary') {
          // 辅路视频流，一般是推屏幕分享的那路流。
          // 1. 在页面中放置一个 id 为 `${params.elementId}_screen` 的 div 标签，用于在 div 标签内播放屏幕分享。业务侧可自定义 div 标签的 id，此处只是举例说明。
          // 2. 播放屏幕分享
          await remoteStream.play(`${params.elementId}_screen`);
        }
      });
      await trtcCloud.join({ roomId: params.roomId });
      return true;
    } catch (error) {
      console.error('拉流播放失败:', error);
    }
  };
}

export default TRTCScreenShare;
